// in DD/MM/YYYY format: 21/12/2024
const dateInDDMMYYYY = '21/12/2024';

export const bannerUpdateTimestamp = new Date(dateInDDMMYYYY.split('/').reverse().join('-')).getTime();
